const PageHeader = ({ eyebrow, title, description }) => {
  return (
    <section className="relative pt-[140px] pb-16 lg:pt-[180px] lg:pb-24 px-6 lg:px-10 overflow-hidden">
      {/* Subtle gradient backdrop */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute inset-0 bg-gradient-to-b from-primary/10 to-transparent" />
        <div
          className="absolute inset-0 opacity-[0.06]"
          style={{
            backgroundImage:
              'radial-gradient(circle at 1px 1px, hsl(var(--accent)) 1px, transparent 0)',
            backgroundSize: '36px 36px',
          }}
        />
      </div>

      <div className="relative max-w-[1300px] mx-auto text-center">
        <div className="flex items-center justify-center gap-3 mb-5">
          <span className="h-px w-10 bg-clay" />
          <span data-testid="page-eyebrow" className="text-[11px] tracking-[0.28em] text-clay font-medium">
            {eyebrow}
          </span>
          <span className="h-px w-10 bg-clay" />
        </div>
        <h1 data-testid="page-title" className="text-[44px] sm:text-[56px] lg:text-[72px] leading-[1.05] font-semibold text-white max-w-4xl mx-auto">
          {title}
        </h1>
        {description && (
          <p className="mt-6 text-[15px] lg:text-[16px] text-white/55 max-w-2xl mx-auto leading-relaxed">
            {description}
          </p>
        )}
      </div>
    </section>
  );
};

export default PageHeader;
